import { getEndpoint } from './endpoints';

const defaultConceptionParam = {
    partialSurface: null,
    activSurface: null,
    leakFlowRate: null,
    rateVolume: null,
};

export const refProperties = {
    state: {
        type: 'properties',
        sort: {},
        pagination: {
            currentPage: 1,
            perPage: 15,
            total: 0,
        },
        properties: [],
        property: {},
        propertyId: null,
        towns: [],
        cities: [],
        sorterFields: {},
        search: { town: null, folderNumber: null, street: null, streetNumber: null, complianceSurveyOnly: null },
    },
    mutations: {
        setProperties(state, payload) {
            state.properties = payload;
        },
        setProperty(state, payload) {
            let { conception } = payload;
            state.property = payload;

            state.property.conception = conception ? conception : defaultConceptionParam;
        },
        setIdProperty(state, payload) {
            state.propertyId = payload.id;
        },
        setPaginationOptions(state, payload) {
            state.pagination.total = payload.total;
        },
        setCurrentPage(state, payload) {
            state.pagination.currentPage = payload.currentPage;
        },
        setTowns: (state, payload) => {
            state.towns = payload;
        },
        setCities: (state, payload) => {
            state.cities = payload;
        },
        initSearchForm(state) {
            state.search = { town: null, folderNumber: null, street: null, streetNumber: null, complianceSurveyOnly: null, sorterFields: null };
            state.pagination.currentPage = 1;
        },
        getSta(state) {
            return state.sorterFields;
        },
    },
    actions: {
        setIdProperty({ commit }, payload) {
            commit('setIdProperty', { id: payload.id });
        },
        async fetchProperties({ commit, rootState, state }, payload) {
            let pageNum = payload && payload.page ? payload.page : state.pagination.currentPage;
            let params = { page: pageNum, per_page: state.pagination.perPage };

            if (payload && payload.sortField && payload.order) {
                params['sorterFields[]'] = payload.sortField + '=' + payload.order;
            }

            const endpoint = getEndpoint(state.type).list;

            if (state.search.complianceSurveyOnly) {
                params['complianceSurveyOnly'] = state.search.complianceSurveyOnly.id;
            }

            if (state.search.town !== null) {
                params['town'] = state.search.town.code;
            }

            Object.entries(state.search).forEach(([keySearch, contentSearch]) => {
                if (contentSearch && keySearch !== 'town' && keySearch !== 'complianceSurveyOnly') {
                    params[keySearch] = contentSearch;
                }
            });

            const { data, headers } = await rootState.app.http.instance.get(endpoint, {
                params: params,
            });

            commit('setProperties', data);
            commit('setPaginationOptions', { total: headers.total });
        },

        async fetchProperty({ commit, rootState, state }, payload) {
            const endpoint = getEndpoint(state.type, payload.id).detail;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setProperty', data);
        },
        async fetchTowns({ commit, rootState, state }) {
            const endpoint = getEndpoint('referential').towns;
            if (state.towns.length == 0) {
                const { data } = await rootState.app.http.instance.get(endpoint);
                commit('setTowns', data);
            }
        },
        async fetchCities({ commit, rootState, state }) {
            const endpoint = getEndpoint('referential').cities;
            if (state.cities.length == 0) {
                const { data } = await rootState.app.http.instance.get(endpoint);
                commit('setCities', data);
            }
        },
    },
    getters: {
        getProperties(state) {
            return state.properties;
        },
        getProperty(state) {
            return state.property;
        },
        getPageCount(state) {
            return Math.ceil(state.pagination.total / state.pagination.perPage);
        },
        getTowns: state => {
            return state.towns;
        },
        getCities: state => {
            return state.cities;
        },
    },
};
